import { useCallback, useEffect, useReducer } from "react"

import { cortexGet } from "./cortexFetch"
import defaultReducer from "../../utils/defaultReducer"

// Package/balance display, polled every 60s like the original widget's
// getPackages() in App.js.
const useBalance = ({ assistantUrl, accessToken, accountcode }) => {
    const [state, setState] = useReducer(defaultReducer, {
        packages: 0,
        maxPackages: 0,
    })

    const refresh = useCallback(async () => {
        if (!assistantUrl || !accessToken || !accountcode) return
        const res = await cortexGet(`${assistantUrl}/accountcodes/${accountcode}/balance`, accessToken)
        if (res.status !== 200) return
        const data = await res.json()
        setState({ packages: data.total - data.balance, maxPackages: data.total })
    }, [assistantUrl, accessToken, accountcode])

    useEffect(() => {
        refresh()
        const intervalId = setInterval(() => { if (accountcode) refresh() }, 60000)
        return () => clearInterval(intervalId)
    }, [refresh, accountcode])

    // Applies the remaining-balance figure a question response already
    // carries, the same way the original widget updated its package counter
    // immediately (globalMaxPackages - question.balance) instead of waiting
    // up to 60s for the next poll.
    const applyRemaining = useCallback((remaining) => {
        setState({ packages: state.maxPackages - remaining })
    }, [state.maxPackages])

    return { ...state, refresh, applyRemaining }
}

export default useBalance
